import { Text } from "../UI"
import { Classes } from "../../theme/Classes"
import { APP_SETTINGS } from "../../hooks/useAppSettings"

export const Header = () => {

    return (
        
        <div style={Classes.Header}>
            <img src= '/logo.png' className="logo" alt="logo" />
            <span style={{color:"red"}}>No</span>
            <span style={{color:"white"}}>Line</span>
        </div>
    )
}